module.exports = __webpack_public_path__ + "assets/icon_study.25ae312f.svg";